import { LuLayoutDashboard } from 'react-icons/lu'
import { FaLayerGroup, FaList, FaStoreAlt, FaUserCog, FaUsersCog, FaUserSecret, FaWallet } from 'react-icons/fa'
import {
    RiCustomerService2Fill,
    RiFileList3Fill,
    RiShoppingCartFill,
    RiMessageLine,
    RiBankFill,
    RiUserSettingsLine,
} from 'react-icons/ri'
import { TbShoppingCartCog } from 'react-icons/tb'
import { RiShieldCheckFill } from 'react-icons/ri'

const appRoutes = [
    {
        text: 'Menu',
        child: [
            {
                url: '/admin',
                text: 'Dashboard',
                icon: <LuLayoutDashboard />,
            },
            {
                active: ['/admin/admins'],
                url: '/admin/admins',
                text: 'Admins',
                icon: <FaUserSecret />,
            },
            {
                active: ['/admin/roles'],
                url: '/admin/roles',
                text: 'Roles',
                icon: <FaUserCog />,
            },
            {
                active: ['/admin/users'],
                url: '/admin/users',
                text: 'Users',
                icon: <FaUsersCog />,
            },
            {
                active: ['/admin/customers'],
                url: '/admin/customers',
                text: 'Customers',
                icon: <FaLayerGroup />,
            },
            {
                active: ['/admin/service-staffs'],
                url: '/admin/service-staffs',
                text: 'Service Staffs',
                icon: <RiCustomerService2Fill />,
            },
            {
                active: ['/admin/stores'],
                url: '/admin/stores',
                text: 'Stores',
                icon: <FaStoreAlt />,
            },
            {
                active: ['/admin/order-requests'],
                url: '/admin/order-requests',
                text: 'Order Requests',
                icon: <RiFileList3Fill />,
            },
            {
                active: ['/admin/orders'],
                url: '/admin/orders',
                text: 'Orders',
                icon: <RiShoppingCartFill />,
            },
            {
                active: ['/admin/order-progress'],
                url: '/admin/order-progress',
                text: 'Work In Progress',
                icon: <TbShoppingCartCog />,
            },
            {
                active: ['/admin/warranty-services'],
                url: '/admin/warranty-services',
                text: 'Warranty Services',
                icon: <RiShieldCheckFill />,
            },
            {
                active: ['/admin/customer-requests'],
                url: '/admin/customer-requests',
                text: 'Complaint Requests',
                icon: <RiMessageLine />,
            },
            {
                active: ['/admin/wallets'],
                url: '/admin/wallets',
                text: 'Wallets',
                icon: <FaWallet />,
            },
            {
                active: ['/admin/withdrawal-requests'],
                url: '/admin/withdrawal-requests',
                text: 'Withdrawal Requests',
                icon: <RiBankFill />,
            },
            {
                active: [
                    '/admin/machine-types',
                    '/admin/machines',
                    '/admin/terms',
                    '/admin/festival-offers',
                    '/admin/service-inspections',
                    '/admin/machine-demos',
                    '/admin/setting',
                ],
                text: 'Master Data',
                icon: <RiUserSettingsLine />,
                child: [
                    {
                        active: ['/admin/machine-types'],
                        url: '/admin/machine-types',
                        text: 'Machine Types',
                    },
                    {
                        active: ['/admin/machines'],
                        url: '/admin/machines',
                        text: 'Machines',
                    },
                    {
                        active: ['/admin/terms'],
                        url: '/admin/terms',
                        text: 'Terms',
                    },
                    {
                        active: ['/admin/festival-offers'],
                        url: '/admin/festival-offers',
                        text: 'Festival Offers',
                    },
                    {
                        active: ['/admin/service-inspections'],
                        url: '/admin/service-inspections',
                        text: 'Service Inspection',
                    },
                    {
                        active: ['/admin/machine-demos'],
                        url: '/admin/machine-demos',
                        text: 'Machine Demo',
                    },
                    {
                        active: ['/admin/setting'],
                        url: '/admin/setting',
                        text: 'Setting',
                    },
                ],
            },
            {
                active: ['/admin/login-history'],
                url: '/admin/login-history',
                text: 'Login History',
                icon: <FaList />,
            },
        ],
    },
]

export default appRoutes
